module.exports = __webpack_public_path__ + "static/media/salmon.8653ab84.ogg";